import { ButtonIcon } from '@delmonicos/shared-design-system-react/src/components/button-icon/button-icon';
import { ButtonColor } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import * as cssTable from '@delmonicos/shared-design-system-react/src/components/table/table.module.scss';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

export interface EmspBoEmspUserListActionsCellProps
  extends CellContext<EmspUserModel, unknown> {}

export const EmspBoEmspUserListActionsCell = (
  props: EmspBoEmspUserListActionsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;
  const navigate = useNavigate();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  const canRead =
    userPermissions &&
    hasAccessTo(userPermissions, {
      resourceName: Resource.EMSP_BO,
      action: ActionsByResource.EMSP_BO.READ_EMSP_USER,
    });

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="row" justifyContent="flex-end">
      {canRead && (
        <ButtonIcon
          icon="eye"
          color={ButtonColor.Ghost}
          onClick={() =>
            navigate(
              generatePath(APP_PATH.EMSP_BO_EMSP_USER.DETAILS, {
                id: row.original.id,
              }),
            )
          }
          className={cssTable.displayOnHover}
        />
      )}
    </Stack>
  );
};
